import { z } from "zod";

export const VOTE_RESULTS = ["left", "right", "skip"] as const;
export type VoteResult = (typeof VOTE_RESULTS)[number];
const metadata = z.string().max(512);

export const ttsVoteInput = z.object({
  id: z.uuid().default(() => crypto.randomUUID()),
  leftSampleId: metadata.min(1),
  rightSampleId: metadata.min(1),
  result: z.enum(VOTE_RESULTS),
  promptId: metadata.default(""),
  leftProvider: metadata.default(""),
  leftModel: metadata.default(""),
  rightProvider: metadata.default(""),
  rightModel: metadata.default(""),
  language: metadata.optional(),
  category: metadata.optional(),
  speed: z.union([metadata, z.number().finite()]).transform(String).optional(),
  gender: metadata.optional(),
  sessionId: metadata.optional(),
});
export type TtsVoteInput = z.output<typeof ttsVoteInput>;

export const publicTtsVote = ttsVoteInput.omit({ id: true, sessionId: true }).extend({
  PK: z.string(),
  result: z.enum(["left", "right"]),
  createdAt: z.iso.datetime(),
});
export type PublicTtsVote = z.output<typeof publicTtsVote>;
